module.exports = __webpack_public_path__ + "img/logotype_pc.50e80b23.svg";